import { useContext, createContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import createApiInstance from "../utilities/apiAuth";
import isTokenExpired from '../utilities/checkTokenExpiration';

const FranchiseeContext = createContext();

export function FranchiseeProvider({ children }) {
  const navigate = useNavigate();
  
  const [franchisees, setFranchisees] = useState([]);
  const [selectedFranchisee, setSelectedFranchisee] = useState({});

  
  const fetchFranchisees = async () => {
    
    if (isTokenExpired()) {
      console.log('Token expired - skipping franchisee fetch');
      return;
    }
    
    const api = createApiInstance(navigate);
    try {
      const token = localStorage.getItem('authToken');
      if (token) {
        const res = await api.get('/franchisees/list');
        setFranchisees(res.data);
      } else {
        console.log('No User Logged In');
      }
    } catch (error) {
      // Don't log token expiration errors to avoid console spam
      if (error.message !== 'Token expired') {
        console.log(error);
      }
    }
  };

  // Fetch franchisees when the provider is initialized
  useEffect(() => {
    fetchFranchisees();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  // Function to refetch the franchisee list
  const refetchFranchisees = async () => {
    await fetchFranchisees();
  };

  const handleRowSelect = (franchisee) => {
    setSelectedFranchisee(franchisee);
    localStorage.setItem('selectedFranchisee', JSON.stringify(franchisee));
  };

  return (
    <FranchiseeContext.Provider
      value={{
        franchisees,
        selectedFranchisee,
        setSelectedFranchisee,
        handleRowSelect,
        refetchFranchisees, // Expose the refetch function
      }}
    >
      {children}
    </FranchiseeContext.Provider>
  );
}

export function useFranchisee() {
  return useContext(FranchiseeContext);
}
